import React from 'react';
import { Conversations } from '../components/site/features/networking/pages';

export const ConversationsLayout = (props) => {

		const { children, location } = props;

		return (
			<main>
				<div className="row">
					<div className="col-xs-12">
						<h1 className="h1 text-center">Your Messages</h1>
					</div>
				</div>
				<div className="row">
					<div className="col-xs-12 col-sm-4">
						<div className="msg-conversation-user user-list-background">
							<Conversations location={ location } />
						</div>
					</div>
					{
						children &&
						<div className="col-xs-12 col-sm-8">
							{ children }
						</div>
					}
				</div>
			</main>
		);
	};



// WEBPACK FOOTER //
// src/client/layouts/ConversationsLayout.js